import { CurrencyCode, SingleRate } from '../schemas';

export interface CurrencyDisplayConfig {
  code: CurrencyCode;
  name: string;
  shortName: string;
  symbol: string;
  flag: string;
  locale: string;
  fractionDigits: number;
}

export const CURRENCY_CONFIGS: Record<CurrencyCode, CurrencyDisplayConfig> = {
  USD: {
    code: 'USD',
    name: 'Dólar Estadounidense (Base)',
    shortName: 'USD',
    symbol: 'US$',
    flag: '🇺🇸',
    locale: 'en-US',
    fractionDigits: 2,
  },
  ARS_BLUE: {
    code: 'ARS_BLUE',
    name: 'Pesos Argentinos (Dólar Blue)',
    shortName: 'ARS Blue',
    symbol: '$',
    flag: '🇦🇷',
    locale: 'es-AR',
    fractionDigits: 0,
  },
  ARS_MEP: {
    code: 'ARS_MEP',
    name: 'Pesos Argentinos (Dólar MEP / Cripto)',
    shortName: 'ARS MEP',
    symbol: '$',
    flag: '🇦🇷',
    locale: 'es-AR',
    fractionDigits: 0,
  },
  ARS_TARJETA: {
    code: 'ARS_TARJETA',
    name: 'Pesos Argentinos (Dólar Tarjeta + Impuestos)',
    shortName: 'ARS Tarjeta',
    symbol: '$',
    flag: '🇦🇷',
    locale: 'es-AR',
    fractionDigits: 0,
  },
  ARS_OFICIAL: {
    code: 'ARS_OFICIAL',
    name: 'Pesos Argentinos (Oficial BNA / Aduana)',
    shortName: 'ARS BNA',
    symbol: '$',
    flag: '🇦🇷',
    locale: 'es-AR',
    fractionDigits: 2,
  },
  BRL: {
    code: 'BRL',
    name: 'Reales Brasileños (Pix / Efectivo)',
    shortName: 'BRL Pix',
    symbol: 'R$',
    flag: '🇧🇷',
    locale: 'pt-BR',
    fractionDigits: 2,
  },
  PYG: {
    code: 'PYG',
    name: 'Guaraníes Paraguayos (Efectivo)',
    shortName: 'PYG',
    symbol: '₲',
    flag: '🇵🇾',
    locale: 'es-PY',
    fractionDigits: 0,
  },
};

/**
 * Converts a base price in USD to any target currency using the active exchange rates
 */
export function convertUsdToCurrency(
  priceUsd: number,
  targetCurrency: CurrencyCode,
  rates: Record<CurrencyCode, SingleRate>
): number {
  if (targetCurrency === 'USD') return priceUsd;
  const rateObj = rates[targetCurrency];
  if (!rateObj || !rateObj.sell) {
    return priceUsd;
  }
  return priceUsd * rateObj.sell;
}

/**
 * Formats a currency amount into a localized human-readable string
 */
export function formatCurrencyAmount(
  amount: number,
  currencyCode: CurrencyCode
): string {
  const config = CURRENCY_CONFIGS[currencyCode] || CURRENCY_CONFIGS.USD;

  try {
    const formattedNumber = new Intl.NumberFormat(config.locale, {
      minimumFractionDigits: config.fractionDigits,
      maximumFractionDigits: config.fractionDigits,
    }).format(amount);

    return `${config.symbol} ${formattedNumber}`;
  } catch {
    return `${config.symbol} ${amount.toFixed(config.fractionDigits)}`;
  }
}
